import { Button, Col, Popconfirm, Row, Space, Table, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { columnsTableMenu as columns } from "./config";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { ListActionButton, Notification } from "components/common";
import { RecycleSVG } from "assets";
import { consultantAndFragmentService } from "api";
import { setDataConsultantAndFragment } from "redux/reducer/consultantAndFragment";
import { formatToCurrencyType } from "helper/common";
import Icon from "assets/icons";
import ModalPrintAddService from "pages/Pay/PayTab/PayDetailTab/TabPay/ModalPrintAddService/ModalPrintAddService";

const AddServicePacket = () => {
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const chiTietGoiDichVuDtos = useAppSelector(
    (e) => e.consultantAndFragment?.data?.dmGoiDichVuDtos
  );
  const dataConsultantAndFragment = useAppSelector(
    (e) => e.consultantAndFragment.data
  );
  const idConsultantAndFragment = useAppSelector(
    (e) => e.consultantAndFragment.idConsultantAndFragment
  );
  const TinhTongGia = (data, name) => {
    if (data) {
      let tongGia = 0;

      data.forEach((goiDichVu) => {
        tongGia += goiDichVu[name];
      });

      return tongGia;
    } else null;
  };
  const handleOnPrint = () => {
    if (!chiTietGoiDichVuDtos.length) {
      Notification("warning", "Chưa có gói dịch vụ BN lựa chọn");
      return;
    }
    setIsShowModalPrint(true);
  };
  const handleOpen = () => {
    setIsShowModalPrint(false);
  };
  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
  };
  useEffect(() => {
    columns.find((e) => e.dataIndex === "tongNbTra").render = (v) => {
      const tongGiaBHYT = TinhTongGia(chiTietGoiDichVuDtos, "giaBH");
      const tongGiaBv = TinhTongGia(chiTietGoiDichVuDtos, "giaBv");
      const mucBVGiam = TinhTongGia(chiTietGoiDichVuDtos, "mucBVGiam");
      const tongNbTra = formatToCurrencyType(
        Math.round(
          (tongGiaBHYT * (1 - 0.8) + (tongGiaBv - tongGiaBHYT) - mucBVGiam) /
            1000
        ) * 1000
      );
      return tongNbTra;
    };
  }, [chiTietGoiDichVuDtos]);
  const dispatch = useAppDispatch();
  columns.find((e) => {
    if (e.dataIndex === "actions") {
      e.render = (
        value,
        _record: { id: number; status: number | string },
        index
      ) => {
        return (
          <ListActionButton>
            <Popconfirm
              className="danger-confirm"
              title={`Đồng ý xoá dịch vụ`}
              onConfirm={async () => {
                try {
                  const chiTietGoiDichVu = chiTietGoiDichVuDtos.filter(
                    (item) => item.id != _record.id
                  );
                  const data = {
                    idPhieuTuVan: idConsultantAndFragment,
                    ngayTao: dataConsultantAndFragment.ngayTao,
                    idGoiDichVus:
                      chiTietGoiDichVu.length > 0
                        ? chiTietGoiDichVu.map((item) => item.id)
                        : [],
                  };
                  const res =
                    await consultantAndFragmentService.postServicePacket(data);
                  const newRes = {
                    ...dataConsultantAndFragment,
                    dmGoiDichVuDtos: res.dmGoiDichVuDtos,
                  };
                  dispatch(setDataConsultantAndFragment(newRes));
                  Notification("success", "Xoá dung dịch vụ thành công ");
                } catch (error) {
                  Notification("error", "Xoá dịch vụ không thành công");
                }
              }}
            >
              <Button type="ghost" icon={<RecycleSVG />} />
            </Popconfirm>
          </ListActionButton>
        );
      };
    }
  });
  return (
    <div>
      <Row
        justify={"space-between"}
        gutter={[16, 16]}
        style={{ alignItems: "center" }}
      >
        <Col>
          <Typography.Text className="header">Gói dịch vụ BN lựa chọn</Typography.Text>
        </Col>
        <Col>
          <Space>
            <Button
              type="ghost"
              className="btn-sub"
              icon={<Icon.printer rev={0} />}
              onClick={handleOnPrint}
            >
              In phiếu thu
            </Button>
          </Space>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={chiTietGoiDichVuDtos}
            bordered
            scroll={{ x: 800, y: 300 }}
            pagination={false}
          />
        </Col>
      </Row>
      <ModalPrintAddService
          isShowModal={isShowModalPrint}
          handleOk={handleOpen}
          handleCancel={handleCancelPrint}
          listGoiDichVuDtos={chiTietGoiDichVuDtos}
          dataTable={dataConsultantAndFragment}
        />
    </div>
    // <div>
    //   <Col>
    //     <Typography.Text strong>Gói dịch vụ BN lựa chọn</Typography.Text>
    //   </Col>
    //   <Col>
    //     <Button
    //       type="ghost"
    //       className="btn-sub"
    //       icon={<Icon.printer rev={0} />}
    //       //  onClick={handleOnPrint}
    //     >
    //       In phiếu thu lẻ
    //     </Button>
    //   </Col>
    //   <Col>
    //     <Space>
    //       <Table
    //         columns={columns}
    //         dataSource={chiTietGoiDichVuDtos}
    //         bordered
    //         scroll={{ x: 800, y: 300 }}
    //         pagination={false}
    //       />
    //     </Space>
    //   </Col>
    //   {/* <div className="header">Gói dịch vụ BN lựa chọn</div> */}
    // </div>
  );
};

export default AddServicePacket;
